var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.shipmentOrder)?_c('order-detail',{key:_vm.reloadkey,attrs:{"shipment-order":_vm.shipmentOrder},on:{"load-shipment":_vm.loadShipmentDetails}}):[_c('b-card',{staticClass:"text-center p-4"},[_c('b-spinner')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }